import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { useShellConfig } from 'contexts/ShellConfigContext';

export default function RoleRoute({ roles, children }) {
  const { user, loading } = useAuth();
  const { homePath } = useShellConfig();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) {
    return <Navigate to={homePath} replace />;
  }

  return children;
}
